// extracted by mini-css-extract-plugin
export var container = "_fl-1";
export var editor = "_fl-2";
export var resizable = "_fl-3";
export var wrapper = "_fl-0";